// 生成guid
const generateGUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}
class CommandManage {
  // 撤销列表
  undoList = []
  // 重做列表
  redoList = []
  // 撤销次数限制
  undoCount = 10
  // 执行的步骤
  executeCount = 0
  // 初始数据
  initData = null
  // 初始数据id
  initFlagId = null
  // 是否已经重置
  isReset = true

  // 初始化
  constructor(initData) {
    this.initData = initData
    this.initFlagId = generateGUID()
    this.initData.id = this.initFlagId
  }
  // 执行了操作
  executeCommand(data) {
    this.isReset = false
    this.undoList.push(data)
    this.redoList = []
    if (this.executeCount < this.undoCount) {
      this.executeCount += 1
    }
  }
  // 撤销
  undoCommand() {
    this.isReset = false
    if (this.undoList.length > 0 && this.executeCount >= 1) {
      this.executeCount -= 1
      const data = this.undoList.pop()
      this.redoList.push(data)
      return {
        executeCount: this.executeCount,
        currentData:
          this.undoList.length <= 0 ? this.initData : this.undoList[this.undoList.length - 1],
        undoList: this.undoList,
        redoList: this.redoList,
      }
    }
    return null
  }
  // 重做
  redoCommand() {
    this.isReset = false
    if (this.redoList.length > 0) {
      if (this.executeCount < this.undoCount) {
        this.executeCount += 1
      }
      const data = this.redoList.pop()
      this.undoList.push(data)
      return {
        executeCount: this.executeCount,
        currentData: data,
        undoList: this.undoList,
        redoList: this.redoList,
      }
    }
    return null
  }
  // 重置操作
  resetCommand() {
    this.isReset = true
    if (this.initData) {
      const commandReset = _.find(this.undoList, ['id', this.initFlagId])
      if (_.isNil(commandReset)) {
        this.undoList.push(this.initData)
        if (this.executeCount < this.undoCount) {
          this.executeCount += 1
        }
        return this.initData
      }
      return null
    }
    return null
  }
}
export { CommandManage }
